
export const getYesOrNo = (booleanValue) => {
  if (booleanValue !== null || booleanValue !== '') {
    if (booleanValue === true) {
      return "Yes";
    } else if (booleanValue === false) {
      return "No";
    } else {
      return "N/A";
    }
  } else {
    return "N/A";
  }
}

export const clone = (object) => {
  return JSON.parse(JSON.stringify(object));
}

// /^\s*$/ -> This will include tab new line
export const isStringWithOnlySpaces = (str) => {
   return /^ *$/.test(str) || !str;
}

export const copy = (id) => {
    /* Get the text field */
    let copyText = document.getElementById(id);

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
}

export const showPassword = (id) => {
  let x = document.getElementById(id);
  console.log(x);
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
}


export const camelCaseToSentence = (str) => {
  return str.replace( /([A-Z])/g, " $1" ).trim();
}

export const scroll = (id, options = {}) =>  {
  document.getElementById(id).scrollIntoView({
    behavior: "smooth",
    block: "end",
    ...options
  });
}

export const cropMessage = (lastChat, size=60) => {
  if (!lastChat || !lastChat.message) return '';
  let msg = lastChat.message;
  // Replace <br> and <br/> with space
  msg = msg.replace(/<br\s*[\/]?>/gi, ' ');
  // Strip out all other HTML tags
  msg = msg.replace(/<\/?[^>]+(>|$)/g, "");
  // Replace &nbsp; with space
  msg = msg.replace(/&nbsp;/gi, ' ');
  return msg.length > size ? msg.substring(0, size) + '...' : msg;
}

